// extracted by mini-css-extract-plugin
export default {"textarea":"d8Td25CWE_W7rply4WsL"};